































import { Component, Prop, Vue } from 'vue-property-decorator'
import { PrepTaskStatus } from '@/models'
import { PREP_TASK_STATUSES, PrepStateView, percent } from '@/utils/production-prep'

/**
 * State of a preparation: its label, the progress bar, the done tasks out of the applicable ones
 * and how many tasks are in each status. The status counters can work as a filter.
 */
@Component
export default class PrepProgressHeader extends Vue {
  @Prop({ required: true }) state: PrepStateView
  @Prop({ required: true }) done: number
  @Prop({ required: true }) total: number
  @Prop({ required: true }) counts: { [status in PrepTaskStatus]: number }
  @Prop({ default: null }) filter: PrepTaskStatus | null
  // Counters as filter buttons: they emit `filter` with their status
  @Prop({ default: false }) filterable: boolean
  // Right aligned, as in the preparation header
  @Prop({ default: false }) right: boolean

  private statuses = PREP_TASK_STATUSES

  get progress(): number {
    return percent(this.done, this.total)
  }
}
